import * as React from 'react';
import { TextField, PrimaryButton, Label, Link } from 'office-ui-fabric-react';
import OverlayComponent from "../common/OverlayComponent";
import { Validator } from "../../validation";
import { Dictionary, ISourceInfo } from "../../entities/common";
import LabellableFieldComponent from '../common/sectionsControl/uiControls/fieldsArea/LabellableFieldComponent';

type Props = {
    readonly: boolean;
    actions: Dictionary<any>;
    sourceInfo?: ISourceInfo;
    dismissPanel?: () => void;
}

const validator = {
    fileUrl: Validator.new().required('Please enter file URL').build()
}

const FileConnectControl = (props: Props) => {
    const [fileUrl, setFileUrl] = React.useState<string | undefined>(props.sourceInfo?.sourceData?.fileUrl);

    const { sourceInfo, readonly, dismissPanel } = props;
    const isLinked = !!sourceInfo;

    const linkToProject = () => {
        if (fileUrl) {
            props.actions.linkToFile(fileUrl.trim());
            dismissPanel && dismissPanel();
        }
    }

    const deleteLink = () => {
        props.actions.deleteLink(sourceInfo?.connectionId);
        dismissPanel && dismissPanel();
    }

    return <>
        {isLinked
            ? <>
                <Label>File URL</Label>
                <Link 
                    className='connected-file-link' 
                    target="_blank" 
                    title={fileUrl} 
                    href={fileUrl}>
                    {fileUrl}
                </Link>
            </>
            : <TextField label="File URL"
                className='file-link'
                disabled={readonly || isLinked}
                placeholder="File URL"
                value={fileUrl}
                title={fileUrl}
                validateOnFocusOut={true}
                onGetErrorMessage={validator.fileUrl.getErrorMessage}
                onChange={(e, _) => setFileUrl(_)} 
            />
        }
        <OverlayComponent isOverlayed={!fileUrl}>
            {
                !isLinked && <PrimaryButton text={`Link file`}
                    disabled={readonly || !validator.fileUrl.isValid(fileUrl)}
                    className="with-top-margin"
                    onClick={linkToProject} />
            }
            {
                isLinked && <PrimaryButton text="Delete link"
                    className="with-top-margin"
                    disabled={readonly || (sourceInfo && sourceInfo.syncStatus.inProgress)}
                    title={!!(sourceInfo && sourceInfo.syncStatus.inProgress) ? "Sync in progress." : undefined}
                    onClick={deleteLink} />
            }
        </OverlayComponent>
    </>;
}

export default FileConnectControl;